import type { ComponentProps } from "react";
import { Input } from "./input";
import { cn } from "../lib/utils";
import { formatCurrency } from "../lib/formatters/number-formatters";

type CurrencyInputProps = Omit<ComponentProps<typeof Input>, "type"> & {
  wrapperClassName?: string;
} & (
    | { mode: "number"; type?: never; onValueChange?: never }
    | {
        mode: "formatted";
        type?: ComponentProps<typeof Input>["type"];
        onValueChange?: (value: number) => void;
      }
  );

/** Native numeric editing or the existing whole-dollar form formatting. */
export function CurrencyInput({
  mode,
  className,
  wrapperClassName,
  value,
  onValueChange,
  ...props
}: CurrencyInputProps) {
  const formatted = mode === "formatted";
  return (
    <div className={cn("relative", wrapperClassName)}>
      <span
        className={cn(
          "absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none",
          !formatted && "text-sm select-none",
        )}
      >
        $
      </span>
      <Input
        value={
          formatted
            ? formatCurrency(
                Number.parseInt(value?.toString() || "0", 10),
              ).replace("$", "")
            : value
        }
        onChange={
          formatted
            ? (event) => {
                const numericValue = event.target.value.replace(/[^0-9]/g, "");
                onValueChange?.(Number.parseInt(numericValue, 10) || 0);
              }
            : undefined
        }
        {...props}
        type={formatted ? props.type : "number"}
        className={cn(formatted ? "pl-8" : "pl-6", className)}
      />
    </div>
  );
}
